import React, { useEffect } from 'react';
import { FixedSizeList } from 'react-window';
import { useSelector, useDispatch } from 'react-redux';
import AutoSizer from 'react-virtualized-auto-sizer';
import PropTypes from 'prop-types';
import { actionTypes } from 'containers/pages/Teams/redux';
import { sort } from './helpers';
import { TeamRow } from './components/TeamRow';
import { ShadowDom } from './components/ShadowDom';

const TeamList = ({ onEditTeam }) => {
  const dispatch = useDispatch();
  const {
    viewList = [],
    sortField,
    sortDirection,
    sortType,
    baseTeamsList,
    searchTerm,
    teamsListIsLoading,
  } = useSelector((state) => state.teamsReduxReducer);

  useEffect(() => {
    const sortedList = sort(viewList, sortType, sortField, sortDirection);

    dispatch({
      type: actionTypes.SET_VIEW_LIST,
      viewList: sortedList,
    });
  }, [sortField, sortDirection, baseTeamsList, searchTerm]);

  const Row = ({ index, style }) => (
    <TeamRow
      key={index}
      team={viewList[index]}
      style={style}
      onEditTeam={onEditTeam}
    />
  );

  return (
    <div style={{ height: 'calc(100vh - 340px)' }}>
      {teamsListIsLoading && <ShadowDom />}
      <AutoSizer defaultWidth="100%">
        {({ height, width }) => (
          <FixedSizeList
            height={height}
            width={width}
            className="m-data-list"
            itemCount={viewList.length}
            itemSize={71}
          >
            {Row}
          </FixedSizeList>
        )}
      </AutoSizer>
    </div>
  );
};

TeamList.propTypes = {
  onEditTeam: PropTypes.func.isRequired,
};

export default TeamList;
